import React from "react";
import { PackageCheck, Truck } from "lucide-react";
import StorefrontHeader from "../components/StorefrontHeader";
import { StorefrontList } from "./Storefront";
import useEmbedResize from "../hooks/useEmbedResize";

/**
 * "Just Dropped" — products that launched for full-price sale (status 'launched').
 * In stock, ships now. Reuses the storefront grid, filtered to launched.
 */
export default function StorefrontJustDropped() {
  useEmbedResize();
  return (
    <div className="dc-store min-h-screen" data-testid="storefront-just-dropped-page">
      <StorefrontHeader active="just-dropped" />

      <div className="max-w-6xl mx-auto px-6 md:px-10 pt-10 md:pt-16 pb-2">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-widest text-[#5B4FE0] font-semibold">
            <PackageCheck size={12} /> In stock
          </div>
          <h1 className="text-3xl sm:text-5xl font-semibold tracking-tight mt-3 leading-tight text-[#111]">
            Just dropped.
          </h1>
          <p className="text-base sm:text-lg text-[#6D7175] mt-4 leading-relaxed">
            Made the cut or just landed — these are live and ship now. No waiting, no threshold.
          </p>
          <div className="mt-6 flex items-center gap-4 text-xs text-[#6D7175]">
            <span className="inline-flex items-center gap-1.5"><Truck size={12} className="text-[#5B4FE0]" /> Ships now</span>
          </div>
        </div>
      </div>

      <div className="-mt-2" data-testid="just-dropped-list">
        <StorefrontList statusFilter="launched" />
      </div>
    </div>
  );
}
